import { PostProperties } from "../types";
import image from "../img/lostGemDeltaFunktionen.jpg";

const post: PostProperties = {
  id: 21,
  title: "Delta Funktionen - Awakenings, Klokgebouw, Eindhoven (06.02.2010)",
  content:
    "Niels Luinenburg a.k.a Delta Funktionen is an artist whose mixes incorporate different genres in order to take the listener on an exciting journey. Retiring the Delta Funktionen project in 2021, Niels is currently working at the Deepgrooves Vinyl Pressing Plant in Leeuwarden.",
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/delta-funktionen-awakenings-klokgebouw-eindhoven-06022010",
  category: "Lost Gem",
  translationsBg: {
    content:
      "Niels Luinenburg, известен като Delta Funktionen, е артист, чиито миксове съчетават различни жанрове, за да поведат слушателя на вълнуващо пътешествие. Слагайки край на проекта Delta Funktionen през 2021 г., Niels в момента работи в завода за пресоване на винилови плочи Deepgrooves в Леуварден.",
  },
};

export default post;
